@if (name) {
  <ion-icon [name]="name"></ion-icon>
}
